// extracted by mini-css-extract-plugin
export default {"wrapper":"TvioWn9Sn7a4vOLosEFj","ruleNumber":"a8eaMn3lcY0f_Ywppb1Z","description":"A9qz0dO9GppsRqRHTM3i"};